import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {I18nModule} from '@spartacus/core';
import {ProvidedByComponent} from './provided-by.component';
import {ProvidedByTooltipComponent} from './provided-by-tooltip/provided-by-tooltip.component';
import {DcpDateFormatterModule, IconButtonTooltipModule} from '@dcp/configurator';

@NgModule({
  declarations: [
    ProvidedByComponent,
    ProvidedByTooltipComponent,
  ],
  imports: [
    CommonModule,
    I18nModule,
    DcpDateFormatterModule,
    IconButtonTooltipModule,
  ],
  exports: [
    ProvidedByComponent,
    ProvidedByTooltipComponent,
  ],
})
export class ProvidedByModule {
}
